import {PHIEU_IN_ENDPOINT, WF_TRACKER} from "../../../../utils/Constant";
import {TypeKeHoach} from "../models/KeHoachModel";

export const WMS_STATUS = {
  build_plan: "build_plan",
  directDownline: "directDownline",
  build_plan_approved: "build_plan_approved",
};

export const CODE_NHAP_KHO = {
  NHA_CUNG_CAP: 'X004',
  TRA_LE: 'X003',
  KHAC: 'X005',
  HOAN_TRA: 'X011',
}

export const TYPE_KE_HOACH: TypeKeHoach[] = [
  {
    name: 'Hỗ trợ kỹ thuật (Thông tin chung)',
    code: CODE_NHAP_KHO.NHA_CUNG_CAP,
    formThongTinChung: 'dohahotrokythuat',
    formVatTu: '',
    pathApi: '',
    pathApiPrint: PHIEU_IN_ENDPOINT.NHAP_KHO.NHA_CUNG_CAP,
    trackerCode: WF_TRACKER.BUILD_PLAN_SUPPORT_TECHNIQUE,
    termModelType: "directDownline"
  }
];

export const TYPE_KB_CB = {
  NHAN_LUC:
    {
      name: 'Nhân lực',
      code: CODE_NHAP_KHO.NHA_CUNG_CAP,
      formThongTinChung: 'dohanhanluc',
      formVatTu: '',
      pathApi: '',
      pathApiPrint: PHIEU_IN_ENDPOINT.NHAP_KHO.NHA_CUNG_CAP,
      trackerCode: WF_TRACKER.BUILD_PLAN,
      termModelType: "directDownline"
    },
  QUA_TRINH_CHUYEN_GIAO:
    {
      name: 'Nhân lực',
      code: CODE_NHAP_KHO.NHA_CUNG_CAP,
      formThongTinChung: 'dohanhanlucquatrinhchuyengiao',
      formVatTu: '',
      pathApi: '',
      pathApiPrint: PHIEU_IN_ENDPOINT.NHAP_KHO.NHA_CUNG_CAP,
      trackerCode: WF_TRACKER.BUILD_PLAN,
      termModelType: "directDownline"
    },
  NGHIEM_THU:
    {
      name: 'Nghiệm thu và thanh lý hợp đồng',
      code: CODE_NHAP_KHO.NHA_CUNG_CAP,
      formThongTinChung: 'dohahotrokythuatnghiemthuhopdong',
      formVatTu: '',
      pathApi: '',
      pathApiPrint: PHIEU_IN_ENDPOINT.NHAP_KHO.NHA_CUNG_CAP,
      trackerCode: WF_TRACKER.BUILD_PLAN_SUPPORT_TECHNIQUE,
      termModelType: "directDownline"
    },
  BIEN_BAN_HO_TRO:
    {
      name: 'Biên bản buổi hỗ trợ',
      code: CODE_NHAP_KHO.NHA_CUNG_CAP,
      formThongTinChung: 'dohahbienbanbuoihotro',
      formVatTu: '',
      pathApi: '',
      pathApiPrint: PHIEU_IN_ENDPOINT.NHAP_KHO.NHA_CUNG_CAP,
      trackerCode: WF_TRACKER.BUILD_PLAN_SUPPORT_TECHNIQUE,
      termModelType: "directDownline"
    },
  BAO_CAO_KET_QUA:
    {
      name: 'Báo cáo kết quả thực hiện hỗ trợ',
      code: CODE_NHAP_KHO.NHA_CUNG_CAP,
      formThongTinChung: 'dohabaocaoketquathuchienhotro',
      formVatTu: '',
      pathApi: '',
      pathApiPrint: PHIEU_IN_ENDPOINT.NHAP_KHO.NHA_CUNG_CAP,
      trackerCode: WF_TRACKER.BUILD_PLAN_SUPPORT_TECHNIQUE,
      termModelType: "directDownline"
    },
}

export const STATUS_CODE = {
  'pending_deployment': 'pending_deployment',
  'pending_acceptance': 'pending_acceptance',
  'being_supported': 'being_supported',
  'pending_report': 'pending_report',
  'approved_done': 'approved_done',
}